import {useEffect} from 'react';
import {useRouter} from 'next/router';
import {Wrapper} from '../styles/WhyUs.style';
import building from '../public/image/whyUs/mobile/building.webp';
import fire from '../public/image/whyUs/mobile/fire-3.webp';
import arrow from '../public/image/whyUs/mobile/arrow-2.webp';
import button_1 from '../public/image/whyUs/mobile/button-1.webp';
import button_2 from '../public/image/whyUs/mobile/button-2.webp';
import WhyUsButtonMobile from '../components/whyUs/WhyUsButtonMobile/WhyUsButtonMobile';
import {setActiveSection, setWhyActive} from '../core/state/navigation.slice';
import {useDispatch, useSelector} from 'react-redux';
import OperationalIntelligence from '../components/whyUs/OperationIntelligence/OperationIntelligenceMobile/OperationIntelligenceMobile';
import DataSecurity from '../components/whyUs/DataSecurity/DataSecurityMobile/DataSecurityMobile';
import ExcellenceMobile from '../components/whyUs/OperationExcellence/ExcellenceMobile/ExcellenceMobile';
import OrganicMobile from '../components/whyUs/OrganicScalability/OrganicMobile/OrganicMobile';
import ManagementMobile from '../components/whyUs/HRManagement/ManagementMobile/ManagementMobile';
import Head from 'next/head';
import useWidth from '../hooks/useWidth';

const WhuUs = () => {
  const dispatch = useDispatch();

  let width = useWidth();

  const whyActiveSection = useSelector((state) => state.navigation.whyActive);

  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);

  const router = useRouter();

  useEffect(() => {
    if (width > 768) {
      router.push('/');
      setTimeout(() => {
        dispatch(setActiveSection(2));
      }, 2000);
    }
    return () => (width = undefined);
  }, [width]);

  return (
    <Wrapper>
      <Head>
        <title>Electa Sourcing: why us</title>
      </Head>
      <div className='lms'>
        <img src={building.src} alt='' className='lms__building' />
        <img src={fire.src} alt='' className='lms__fire' />
        <img src={arrow.src} alt='' className='lms__arrow' />
        <div className='lms__text'>
          <div className='lms__text__first'>The</div>
          <div className='lms__text__second'>LMS</div>
          <div className='lms__text__third'>
            Model
            <br /> Guarantees
          </div>
        </div>
      </div>
      <div className='whyus_buttons'>
        <WhyUsButtonMobile
          title='Organic Scalability'
          background={button_1.src}
          setColor='#b84616'
          setReverseColor='#722e0a'
          close={whyActiveSection === 1 ? true : false}
          onClick={(e) => {
            if (whyActiveSection === 1) {
              dispatch(setWhyActive(-1));
            } else {
              dispatch(setWhyActive(1));
            }

            setTimeout(() => {
              window.scrollTo({
                top: window.innerHeight * 0.65 - 75,
                behavior: 'smooth',
              });
            }, 600);
          }}
          index={50}
        />
        <OrganicMobile active={whyActiveSection == 1} />

        <WhyUsButtonMobile
          title='Operational Excellence'
          background={button_2.src}
          setColor='#722e0a'
          setReverseColor='#722e0a'
          close={whyActiveSection === 2 ? true : false}
          onClick={(e) => {
            if (whyActiveSection === 2) {
              dispatch(setWhyActive(-1));
            } else {
              dispatch(setWhyActive(2));
            }

            setTimeout(() => {
              window.scrollTo({
                top: window.innerHeight * 0.72 - 75,
                behavior: 'smooth',
              });
            }, 600);
          }}
          index={40}
        />
        <ExcellenceMobile active={whyActiveSection == 2} />

        <WhyUsButtonMobile
          title='Operational Intelligence'
          background={button_1.src}
          setColor='#b84616'
          setReverseColor='#722e0a'
          close={whyActiveSection === 3 ? true : false}
          onClick={(e) => {
            if (whyActiveSection === 3) {
              dispatch(setWhyActive(-1));
            } else {
              dispatch(setWhyActive(3));
            }

            setTimeout(() => {
              window.scrollTo({
                top: window.innerHeight * 0.79 - 75,
                behavior: 'smooth',
              });
            }, 600);
          }}
          index={30}
        />

        <OperationalIntelligence active={whyActiveSection == 3} />

        <WhyUsButtonMobile
          title='Panoramic HR Management'
          background={button_2.src}
          setColor='#722e0a'
          setReverseColor='#b84616'
          close={whyActiveSection === 4 ? true : false}
          onClick={(e) => {
            if (whyActiveSection === 4) {
              dispatch(setWhyActive(-1));
            } else {
              dispatch(setWhyActive(4));
            }

            setTimeout(() => {
              window.scrollTo({
                top: window.innerHeight * 0.86 - 75,
                behavior: 'smooth',
              });
            }, 600);
          }}
          index={20}
        />
        <ManagementMobile active={whyActiveSection == 4} />

        <WhyUsButtonMobile
          title='Optimized Data Security'
          background={button_1.src}
          setColor='#722e0a'
          setReverseColor='#722e0a'
          close={whyActiveSection === 5 ? true : false}
          onClick={(e) => {
            if (whyActiveSection === 5) {
              dispatch(setWhyActive(-1));
            } else {
              dispatch(setWhyActive(5));
            }
            setTimeout(() => {
              window.scrollTo({
                top: window.innerHeight * 0.93 - 75,
                behavior: 'smooth',
              });
            }, 600);
          }}
          index={10}
        />
        <DataSecurity active={whyActiveSection == 5} />
      </div>
    </Wrapper>
  );
};

export default WhuUs;
